import { standardListener } from '../config/vars';
import { trigger } from '../lib/event';

export default class Faccordion {

  constructor(el) {

    this.el = el;

    this.group = el.getAttribute('data-group');

    // special accordion in the payment area
    this.fakeEventHandler = this.fakeGroupEvent.bind(this);

    this.el.addEventListener(standardListener, this.fakeEventHandler, false);

  }

  fakeGroupEvent() {

    // ¯\_(ツ)_/¯
    // most useless and overly complex object I ever used.
    // SHAME ON YOU, WHOEVER DID THE ACCORDION!
    const fakeData = {
      data: {
        collapse: {
          group: this.group
        }
      }
    };

    trigger(this.el, 'accordion-open', fakeData);
  }
};
